// ProfileMenu.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import { FaArrowRightFromBracket } from "react-icons/fa6";
import { menuItems } from "../../constants/data";

import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { handleLogout } from "../../utils/data";

const ProfileMenu = () => {
	const { t, i18n } = useTranslation();

	return (
		<div className="space-y-3">
			<div className="w-full border rounded-xl overflow-hidden">
				{/* Menu List */}
				<div >
					{menuItems.map((item: any, idx: number) => (
						<NavLink
							key={idx}
							to={`/me${item.link}`}
							end
							className={({ isActive }) =>
								`w-full flex justify-between items-center px-4 py-4 text-sm border-b 
        						${isActive ? "text-primary font-medium border-primary" : "text-textSecond hover:bg-gray-50"}`
							}
						>
							{i18n.language === "ar" ? item.title_ar : item.title_en}
							<span>
								{i18n.language === "ar" ? <MdArrowBackIos /> : <MdArrowForwardIos />}
							</span>
						</NavLink>
					))}
				</div>

				{/* Logout */}
				<button onClick={() => handleLogout()} className="w-full flex justify-between items-center px-4 py-3 text-red-600 text-sm font-medium">
					{t("logout")}
					<FaArrowRightFromBracket />
				</button>
			</div>
		</div>
	);
};

export default ProfileMenu;
